import * as React from 'react';
import SVGInline from 'react-svg-inline';

import styles from './Blob.scss';

import blob from '../Icon/blob.svg';

interface BlobProps {
  top?: string;
  bottom?: string;
  image?: string;
}

const Blob: React.SFC<BlobProps> = ({ top, bottom, image }) => (
  <div style={{ top, bottom, left: 0, position: 'absolute', zIndex: -1 }}>
    <SVGInline svg={image ? image : blob} className={styles.blob} />
  </div>
);

export default Blob;



// WEBPACK FOOTER //
// /www/client/src/components/Blob/Blob.tsx